exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".addonssingleselect{padding-top:4px;padding-bottom:4px}", ""]);

// exports
